module.exports = __webpack_public_path__ + "img/7b3e39ff066de7577886d3160d535ff3.71e36a63.png";